import React from "react";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { ReactComponent as DeleteSlotIcon } from "../../assets/svg/DeleteIcon.svg";
import { DAYS_DROPDOWN_OPTIONS, SERVICE_TYPES } from "../../../config/constants";
import { PlasticBagconfigurationViewUtils, ServiceActiveFlagViewUtils } from "../CountrySettingView";
import MultiSelectBox from "../../common/MultiSelectBox/MultiSelectBox";
import CountryDefaultTypeDatePicker from "../CountryDefaultTypeDatePicker";
import { CalendarHolidayInterface, COUNTRY_SETTING_TEXT_CONSTANT, MinuteBasedConfigInterface } from "../CountrySettingsUtils";
import { isArrayValid } from "../../../utils/DataUtils";

interface RenderDefaultTypeDetailsInterface {
  classes: any;
  defaultDetails: MinuteBasedConfigInterface;
  handleBagChargeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  weeklyHolidays: string[];
  setWeeklyHolidays: (value: string[]) => void;
  defaultDateState: any;
  handleDateChangeEvent: any;
  handleCancel: any;
  handleCalendarHoliday: (event: React.MouseEvent<SVGSVGElement>, action: string, date: string) => void;
  calendarHoliday: CalendarHolidayInterface[];
  handleServiceTypeActiveChange: (event: React.ChangeEvent<HTMLInputElement>, serviceTypeName: string) => void;
  serviceTypeName: string;
  handlePlasticBagChange: (event: React.ChangeEvent<HTMLInputElement>, name: string) => void;
  handleEditBagCharges: (name: string) => void;
}

const RenderDefaultTypeDetails = (props: RenderDefaultTypeDetailsInterface) => {
  const { classes, defaultDetails, serviceTypeName, handleBagChargeChange, weeklyHolidays, setWeeklyHolidays, defaultDateState, handleDateChangeEvent, handleCancel, handleCalendarHoliday, calendarHoliday, handleServiceTypeActiveChange, handlePlasticBagChange, handleEditBagCharges } = props;

  return (
    <Card className={classes.serviceTypeCard}>
      <CardContent>
        <Grid container justifyContent="flex-start" spacing={1}>
          <ServiceActiveFlagViewUtils
            classes={classes}
            serviceTypeName={serviceTypeName}
            serviceActiveFlag={defaultDetails.serviceActive}
            isDisabled={false}
            handleServiceTypeActiveChange={handleServiceTypeActiveChange}
          />
          <PlasticBagconfigurationViewUtils
            classes={classes}
            bagChargeEnabled={defaultDetails.bagChargeEnabled}
            handleBagChargeChange={handleBagChargeChange}
            name={serviceTypeName ?? SERVICE_TYPES.DEFAULT}
            itemsPerBag={defaultDetails.itemsPerBag}
            bagCharges={defaultDetails.bagCharges}
            editBagCharge={defaultDetails.editBagCharge}
            handlePlasticBagChange={handlePlasticBagChange}
            handleEditBagCharges={handleEditBagCharges}
            newPlasticBagCharges={defaultDetails.newPlasticBagCharges}
          />
          <Grid item xs={3}>
            <>
              <Grid item xs={12}>
                <Typography className={classes.formControlLabel}>{COUNTRY_SETTING_TEXT_CONSTANT.WEEKLY_HOLIDAYS}</Typography>
              </Grid>
              <Grid item xs={12} className={classes.defaultHolidayGridItem}>
                <MultiSelectBox name="holidays" menuitems={DAYS_DROPDOWN_OPTIONS} value={weeklyHolidays} onChange={setWeeklyHolidays} />
              </Grid>
              {isArrayValid(weeklyHolidays) && weeklyHolidays?.map((holiday: string, index: number) => (
                <Grid item xs={12} className={classes.defaultHolidayGridItem} key={`${index}-${holiday}`}>
                  <Typography className={`${classes.formControlLabel} ${classes.capitalize}`}>{holiday}</Typography>
                </Grid>
              ))}
            </>
          </Grid>
          <Grid item xs={3}>
            <>
              <Grid item xs={12}>
                <Typography className={classes.formControlLabel}>{COUNTRY_SETTING_TEXT_CONSTANT.CALENDAR_HOLIDAYS}</Typography>
              </Grid>
              <Grid item xs={12} className={classes.defaultHolidayGridItem}>
                <Grid container justifyContent="flex-start" spacing={1}>
                  <Grid item xs={10}>
                    <CountryDefaultTypeDatePicker
                      classes={classes}
                      defaultDateState={defaultDateState}
                      handleDateChangeEvent={handleDateChangeEvent}
                      handleCancel={handleCancel}
                    />
                  </Grid>
                  <Grid item xs={2} className={classes.addCalendarDateIconGridItem}>
                    <AddCircleOutlineIcon
                      className={classes.addCalendarDateIconStyle}
                      onClick={(e: React.MouseEvent<SVGSVGElement>) =>
                        handleCalendarHoliday(
                          e,
                          COUNTRY_SETTING_TEXT_CONSTANT.ADD,
                          defaultDateState.dateLabel
                        )
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              {isArrayValid(calendarHoliday) &&
                calendarHoliday
                  .filter((holiday: CalendarHolidayInterface) => holiday.offDate || holiday.dateLabel)
                  .map((holiday: CalendarHolidayInterface, index: number) => (
                    <Grid container spacing={1} key={`${index}-${holiday.offDate}`}>
                      <Grid item xs={12} className={classes.defaultCustomHolidayCalendarGridItem}>
                        <DeleteSlotIcon
                          className={classes.deleteCalendarIconStyle}
                          onClick={(e: React.MouseEvent<SVGSVGElement>) =>
                            handleCalendarHoliday(
                              e,
                              COUNTRY_SETTING_TEXT_CONSTANT.REMOVE,
                              holiday.offDate ?? holiday.dateLabel
                            )
                          }
                        />
                        <Typography className={classes.formControlLabel}>
                          {holiday.offDate || holiday.dateLabel}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))
              }
            </>
            </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default React.memo(RenderDefaultTypeDetails);
